import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Package, Wrench, Image as ImageIcon, Newspaper, EnvelopeOpen, Calendar, Receipt, Envelope, VideoCamera } from "@phosphor-icons/react";

const StatCard = ({ icon: Ic, label, value, accent = "#ccff00", testid }) => (
  <div className="card-dark p-6" data-testid={testid}>
    <Ic size={32} weight="duotone" style={{ color: accent }} />
    <div className="display-font text-4xl font-black mt-4">{value}</div>
    <div className="label-tag mt-1">{label}</div>
  </div>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState({ products: 0, services: 0, portfolio: 0, blog: 0, vlogs: 0, contacts: 0, quotes: 0, bookings: 0, newsletter: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/products"), api.get("/services"), api.get("/portfolio"), api.get("/blog"), api.get("/vlogs"),
      api.get("/admin/contacts"), api.get("/admin/quotes"), api.get("/admin/bookings"), api.get("/admin/newsletter"),
    ]).then(([p, s, po, b, v, c, q, bk, n]) => setStats({
      products: p.data.length, services: s.data.length, portfolio: po.data.length, blog: b.data.length, vlogs: v.data.length,
      contacts: c.data.length, quotes: q.data.length, bookings: bk.data.length, newsletter: n.data.length,
    })).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="label-tag mb-3 slash">Overview</div>
      <h1 className="display-font text-4xl font-black uppercase mb-10">Control Room</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={Package}      label="Products"   value={stats.products}   testid="stat-products" />
        <StatCard icon={Wrench}       label="Services"   value={stats.services}   testid="stat-services" accent="#00f0ff" />
        <StatCard icon={ImageIcon}    label="Portfolio"  value={stats.portfolio}  testid="stat-portfolio" />
        <StatCard icon={Newspaper}    label="Blog posts" value={stats.blog}       testid="stat-blog" accent="#00f0ff" />
        <StatCard icon={VideoCamera}  label="Vlogs"      value={stats.vlogs}      testid="stat-vlogs" />
        <StatCard icon={EnvelopeOpen} label="Messages"   value={stats.contacts}   testid="stat-contacts" accent="#00f0ff" />
        <StatCard icon={Receipt}      label="Quotes"     value={stats.quotes}     testid="stat-quotes" />
        <StatCard icon={Calendar}     label="Bookings"   value={stats.bookings}   testid="stat-bookings" accent="#00f0ff" />
        <StatCard icon={Envelope}     label="Subscribers"value={stats.newsletter} testid="stat-newsletter" />
      </div>
    </div>
  );
}
